import styled from 'styled-components'
import bg from '@/images/bg.jpg'
const HomeWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  text-align: center;
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  @keyframes runcircle {
    0% {
      transform: scale(0.5);
      opacity: 1;
    }

    45% {
      transform: scale(0.8);
      opacity: 0.7;
    }

    90% {
      transform: scale(1.2);
      opacity: 0;
    }

    to {
      transform: scale(1.2);
      opacity: 0;
    }
  }

  @keyframes borderrun {
    0% {
      border: 3px solid white;
    }

    20% {
      border-top-color: transparent;
    }

    40% {
      border-top-color: transparent;
      border-right-color: transparent;
    }

    60% {
      border-top-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }

    80% {
      border-color: transparent;
    }

    to {
      border-color: transparent;
    }
  }

  .border {
    padding: 0.2rem 1rem;
    box-sizing: border-box;
    border: 3px solid transparent;
    border-radius: 5px;
    animation: borderrun 4s linear infinite alternate;
    padding: 10px 20px;
  }

  .border-red {
    border-color: red;
  }

  .border-light {
    border-color: lightblue;
  }

  .title {
    font-size: min(10vw, 3rem);
    color: #fff;
    cursor: pointer;
    margin-bottom: 20px;
  }
  .circle {
    margin-top: 0.5rem;
    .circle-item {
      display: inline-block;
      width: 1rem;
      height: 1rem;
      margin: 0 0.3rem;
      border-radius: 50%;
      animation: runcircle 2s infinite linear;
      &:nth-of-type(1) {
        background-color: #ff4242;
        animation-delay: 0.1s;
      }
      &:nth-of-type(2) {
        background-color: #72ff7d;
        animation-delay: 0.2s;
      }
      &:nth-of-type(3) {
        background-color: #42e5ff;
        animation-delay: 0.3s;
      }
      &:nth-of-type(4) {
        background-color: #ffda72;
        animation-delay: 0.4s;
      }
    }
  }
`

export default HomeWrapper
